// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__dUdGK","containerBg":"style_containerBg____U5H","question":"style_question__RI4C7","text":"style_text__BPsfp","button":"style_button___cYIR"};